module.exports = __webpack_public_path__ + "static/fonts/SourceSansPro-Italic.addc60a.woff2";